export default "__VITE_ASSET__Cmq2cVKq__"